export const TOGGLE_LOGIN           = 'TOGGLE_LOGIN';
export const TOGGLE_SIGNUP          = 'TOGGLE_SIGNUP';
export const TOGGLE_FORGOT          = 'TOGGLE_FORGOT';
export const TOGGLE_RESET           = 'TOGGLE_RESET';
export const SIGNUP_PROCESS         = 'SIGNUP_PROCESS';
export const ADD_BRAND              = 'ADD_BRAND';
